import React from "react";
import { Box } from "@mui/material";
import type { NetworkFlagCell } from "../../../services/networkDashboard";

const COLORS: Record<
  NetworkFlagCell["status"],
  { dot: string; ring: string }
> = {
  ok: { dot: "#5d8f7a", ring: "#dfeae3" },
  warn: { dot: "#c89234", ring: "#f5e6c5" },
  alert: { dot: "#b85c5c", ring: "#f1d8d8" },
  neutral: { dot: "#8a98a3", ring: "#e5e9ec" },
};

export default function NetworkFlagDot({ cell }: { cell?: NetworkFlagCell }) {
  const status = cell?.status ?? "neutral";
  const c = COLORS[status] ?? COLORS.neutral;
  return (
    <Box
      sx={{
        width: 10,
        height: 10,
        borderRadius: "50%",
        bgcolor: c.dot,
        boxShadow: `0 0 0 3px ${c.ring}`,
        display: "inline-block",
      }}
      title={cell?.value != null ? String(cell.value) : undefined}
    />
  );
}
